import React, { useContext, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../AuthContext';
import { useDispatch } from 'react-redux';
import { hideComponents } from '../store';

const ProtectedRoute = ({
  element: Component,
  fallbackElement: FallbackComponent,
  roles,
  projecttype,
  ...rest
}) => {
  const { authState, loading, clientLoginformData } = useContext(AuthContext);
  const dispatch = useDispatch();

  useEffect(() => {
    if (authState.token && roles && !roles.includes(authState.user?.role)) {
      dispatch(hideComponents({ showHeader: false, showSidebar: false }));
    } else {
      dispatch(hideComponents({ showHeader: true, showSidebar: true }));
    }
  }, [dispatch, authState]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!authState.token) {
    if (clientLoginformData?.slug) {
      return <Navigate to={`/login/${clientLoginformData?.slug}`} />;
    } else {
      return <Navigate to="/login" />;
    }
  }

  if (roles && !roles.includes(authState.user?.role)) {
    return <Navigate to="/not-authorized" />;
  }

  // Skip feature access checks if projecttype is null or undefined
  if (projecttype != null && authState.user?.role !== 1 && authState.featureAccess != null) {
    // Default to true if the specific flag is missing
    const isMenuEnabled = authState.featureAccess.menuQuizEnabled !== false;
    const isAihEnabled = authState.featureAccess.aihEnabled !== false;

    if (projecttype === 'menusystem' && !isMenuEnabled) {
      return <Navigate to="/not-authorized" />;
    }
    if (projecttype === 'aihsystem' && !isAihEnabled) {
      return <Navigate to="/not-authorized" />;
    }
  }

  if (authState.user.role === 1) {
    return <Component {...rest} />;
  } else if (authState.user.role === 2) {
    return FallbackComponent ? <FallbackComponent {...rest} /> : <Component {...rest} />;
  }

  return <Navigate to="/not-authorized" />;
};

export default ProtectedRoute;
